/**
 * Форматирует дату в формат dd.mm.yyyy
 * @param date - дата в виде строки или объекта Date
 * @returns отформатированная дата в формате dd.mm.yyyy
 */
export const formatDate = (date: string | Date): string => {
  if (!date) return '-';
  
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  if (isNaN(dateObj.getTime())) return '-';
  
  const day = dateObj.getDate().toString().padStart(2, '0');
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
  const year = dateObj.getFullYear();
  
  return `${day}.${month}.${year}`;
};

/**
 * Форматирует дату для отображения в таблицах
 * @param date - дата в виде строки или объекта Date
 * @returns отформатированная дата в формате dd.mm.yyyy или '-'
 */
export const formatTableDate = (date: string | Date | null | undefined): string => {
  if (!date) return '-';
  return formatDate(date);
};

